<template>
  <div class="register-wrap">
    <authLeft/>
    <div class="register-right">
      <div class="register-form">
      <div class="data-table-list-nolist">
        <img src="../../assets/404.png" style="opacity:0.5" alt />
        <div style="font-size:20px; font-weight:900; margin-bottom:10px;">404 NOT FOUND</div>
        <div style="margin-bottom: 30px;">お探しのページにはアクセスできません</div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import authLeft from "./auth_left";

export default {
  name: "register",
  components: {
    authLeft
  },
  data() {
    return {
    };
  },
  mounted() {},
  methods: {
  }
};
</script>